<div class="truck-details-dialog">
  <div class="dialog-layout">
    <h2 class="dialog-h2" *ngIf="truck.id != null">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.edit.title"></sc-dictionary-label>
    </h2>
    <h2 class="dialog-h2" *ngIf="truck.id == null">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.register.title"></sc-dictionary-label>
    </h2>

    <div class="dialog-content truck-details-dialog-content">

      <form #truckForm="ngForm">
        <div class="header-area">
          <div class="row">
            <h5>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.title"></sc-dictionary-label>
            </h5>
          </div>
          <div class="row">

            <mat-form-field class="col first" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.numberPlate"></sc-dictionary-label>
              </mat-label>
              <input [formControl]="numberPlateControl" type="text" name="numberPlate"
                [required]="cps.isPropertyTrue('ui-component.truck-details-dialog.number-plate.min-length', true)"
                [minlength]="+cps.getPropertyValue('ui-component.truck-details-dialog.number-plate.min-length', '0')"
                [maxlength]="100" matInput [matAutocomplete]="autocomplateNumberplate"
                [readonly]="readonly">
              <mat-autocomplete autoActiveFirstOption #autocomplateNumberplate="matAutocomplete"
                [displayWith]="getDisplayFn()" (optionSelected)="numberplateAutocompleteSelection($event)">
                <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let truckDetails of autocomplateTrucks" [value]="truckDetails">
                    <span>{{truckDetails.numberPlate}}</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="col" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.driver"></sc-dictionary-label>
              </mat-label>
              <input matInput name="driver" #name="ngModel" [(ngModel)]="truck.driver"
                [required]="cps.isPropertyTrue('ui-component.truck-details-dialog.driver.min-length', true)"
                [maxlength]="255" [readonly]="readonly"
                [minlength]="+cps.getPropertyValue('ui-component.truck-details-dialog.driver.min-length', '0')"
                [maxlength]="255">
            </mat-form-field>

            <mat-form-field class="col last" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.coDriver"></sc-dictionary-label>
              </mat-label>
              <input matInput name="coDriver" #firstName="ngModel" [(ngModel)]="truck.coDriver"
                [minlength]="+cps.getPropertyValue('ui-component.truck-details-dialog.co-driver.min-length', '0')"
                [required]="cps.isPropertyTrue('ui-component.truck-details-dialog.co-driver.min-length', true)"
                [maxlength]="255"
                [readonly]="readonly">
            </mat-form-field>

          </div>
          <div class="row">
            <mat-form-field class="col first" appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.carrier"></sc-dictionary-label>
              </mat-label>
              <input matInput name="carrier" #firstName="ngModel" [(ngModel)]="truck.carrier"
                [minlength]="+cps.getPropertyValue('ui-component.truck-details-dialog.carrier.min-length', '0')"
                [required]="cps.isPropertyTrue('ui-component.truck-details-dialog.carrier.min-length', true)"
                [maxlength]="255"
                [readonly]="readonly">
            </mat-form-field>
            <mat-form-field class="col " appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.masterdata.supplier"></sc-dictionary-label>
              </mat-label>
              <input matInput name="supplier" #firstName="ngModel" [(ngModel)]="truck.supplier"
                [minlength]="+cps.getPropertyValue('ui-component.truck-details-dialog.supplier.min-length', '0')"
                [required]="cps.isPropertyTrue('ui-component.truck-details-dialog.supplier.min-length', true)"
                [maxlength]="255"
                [readonly]="readonly">
            </mat-form-field>
            <div class="col first">
              <mat-checkbox name="useGlobalConnect" [(ngModel)]="truck.useGlobalConnect"
                [disabled]="!useGlobalConnectEditable">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.useGlobalConnect"></sc-dictionary-label>
              </mat-checkbox>
            </div>
          </div>
          <div class="row" *ngIf="serviceVehiclesEnabled">
            <mat-checkbox class="col first" name="serviceTruck" [(ngModel)]="truck.serviceTruck">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.service-truck"></sc-dictionary-label>
            </mat-checkbox>
          </div>

        </div>
        <div class="row">
          <h5>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.truck-details-dialog.supplementaryequipment.title"></sc-dictionary-label>
          </h5>
        </div>
        <app-truck-supplementary-equipment [truck]="truck" #truckSupplementaryEquipmentComponent>
        </app-truck-supplementary-equipment>
      </form>
    </div>
    <app-service-response [responseMessages]="responseMessages"></app-service-response>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" [mat-dialog-close]="true"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
      <sc-save-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled() || isLoading"
      *ngIf="!readonly" primary></sc-save-button>
    </sc-actionbar>

  </div>
</div>
